module.exports = __webpack_public_path__ + "32194e02049a53df82b262c7294c6a3b.woff2";


/*****************
 ** WEBPACK FOOTER
 ** ./src/styles/fonts/fontello/fontello-webfont.woff2
 ** module id = ./src/styles/fonts/fontello/fontello-webfont.woff2
 ** module chunks = 0
 **/